import script from "./confirm-change-account-detail-template-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm-change-account-detail-template-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__